import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19eede1f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "partnersHome" }
const _hoisted_2 = { class: "img-container" }
const _hoisted_3 = { class: "container mt-2 mb-5 d-none" }
const _hoisted_4 = { class: "w-100 text-primary text-right" }
const _hoisted_5 = { class: "d-flex justify-content-end list-unstyled" }
const _hoisted_6 = { class: "mx-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bi bi-person-fill" }, null, -1))
const _hoisted_8 = { class: "mx-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bi bi-lock-fill" }, null, -1))
const _hoisted_10 = { class: "container-fluid px-md-5 px-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-primary text-capitalize my-lg-3 my-2" }, " Innovation with Partner ", -1))
const _hoisted_12 = {
  key: 0,
  class: "row"
}
const _hoisted_13 = {
  key: 1,
  class: "no_data_mini"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-primary" }, "No Innovation with Partner!", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 2,
  class: "row"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-center mb-3 py-2 text-primary fw-normal" }, " view more... ", -1))
const _hoisted_18 = { class: "container-fluid px-md-5 my-5" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-lg-8 mb-3" }
const _hoisted_21 = { class: "col-lg-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WelcomeScreen = _resolveComponent("WelcomeScreen")!
  const _component_WelcomeImageLoader = _resolveComponent("WelcomeImageLoader")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Card = _resolveComponent("Card")!
  const _component_InnovationAndPartnerList = _resolveComponent("InnovationAndPartnerList")!
  const _component_DistributionAndPartnershipView = _resolveComponent("DistributionAndPartnershipView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("section", _hoisted_2, [
      _createVNode(_component_WelcomeScreen, {
        onLoaded: _ctx.onImgLoad,
        welcomeDetail: _ctx.Welcome
      }, null, 8, ["onLoaded", "welcomeDetail"])
    ], 512), [
      [_vShow, _ctx.isLoaded]
    ]),
    _withDirectives(_createVNode(_component_WelcomeImageLoader, null, null, 512), [
      [_vShow, !_ctx.isLoaded]
    ]),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          _createElementVNode("li", _hoisted_6, [
            _createVNode(_component_router_link, { to: "/partner/register" }, {
              default: _withCtx(() => [
                _hoisted_7,
                _createTextVNode("Register")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_8, [
            _createVNode(_component_router_link, { to: "/partner/login" }, {
              default: _withCtx(() => [
                _hoisted_9,
                _createTextVNode("Log in")
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_10, [
      _hoisted_11,
      (_ctx.datas.length === 0 && _ctx.loading === true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
              return _createElementVNode("div", {
                class: "col-lg-3 col-md-4 col-6",
                key: i
              }, [
                _createVNode(_component_Skeleton, {
                  width: "100%",
                  height: "10rem",
                  class: "mb-3"
                })
              ])
            }), 64))
          ]))
        : _createCommentVNode("", true),
      (_ctx.datas.length === 0 && _ctx.loading === false)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
        : _createCommentVNode("", true),
      (_ctx.datas.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.datas, (item, i) => {
              return (_openBlock(), _createBlock(_component_Card, {
                key: i,
                body: item,
                card: _ctx.cardStyle2,
                route: `/partners/partner-on-proposal/${item.id}?id=${item.id}`
              }, null, 8, ["body", "card", "route"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.datas.length >= 4)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 3,
            to: "/partners/partner-on-proposal"
          }, {
            default: _withCtx(() => [
              _hoisted_17
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("section", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_InnovationAndPartnerList)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_DistributionAndPartnershipView)
        ])
      ])
    ])
  ]))
}